import React from 'react';

import type { ExtensionManifest } from '@atlaskit/editor-common/extensions';

import { EXTENSION_KEY, EXTENSION_TYPE } from '../../../extensionConstants.ts';

const EmptyDiv = () => <div data-extension-key="hide" />;

// The "hide" extension is an artefact of a previous extension supported in DC for DC to Cloud migration
// This code defines its behaviour for renderer, which is just to display nothing
// In editor it is just a generic extension block which contains content inside
// which is handled by default unknown extension behaviour defined in platform/packages/editor/editor-common/src/extensions/extension-handlers.tsx
export const hideExtension: ExtensionManifest = {
	type: EXTENSION_TYPE.MACRO_CORE,
	key: EXTENSION_KEY.HIDE,
	title: 'Hide',
	description: 'Legacy hide macro',
	// icon is left empty because this is only fixing behaviour for migrated content in renderer
	// this macro cannot be inserted in a normal flow via the editor
	icons: {
		'48': () => Promise.resolve({ default: () => null }),
	},
	modules: {
		nodes: {
			default: {
				type: 'bodiedExtension',
				render: async () => EmptyDiv,
			},
		},
	},
};
